import { i18n } from 'app/utils/i18n';
import { NewDropdown } from 'app/components/ui';
import { Typography } from 'app/components/ui';

interface TaxonomyOption {
  label: string;
  value: string;
}

interface TaxonomyProps {
  currentValue: string;
  onValueChange: (value: string) => void;
  options: TaxonomyOption[];
}

export const TaxonomyPicker = ({ currentValue, options, onValueChange }: TaxonomyProps) => {
  if (!options.length) {
    return (
      <Typography variant="body-5" fontWeight="bold" color="#547ba2">
        {i18n('taxonomy.no.taxonomies.found')}
      </Typography>
    );
  }
  return <NewDropdown currentValue={currentValue} label={`${i18n('taxonomy.title')}:`} options={options} onUpdate={onValueChange} showSelectBox />;
};
